export const localizationStringsFr = {
  scan_the_front_side: 'Scannez le recto du document',
  scan_data_page: 'Scannez la page de données du document',
  scan_top_page: 'Scannez la page du haut',
  scan_left_page: 'Scannez la page de gauche',
  scan_right_page: 'Scannez la page de droite',
  flip_document: 'Retournez le document',
  wrong_top: 'Déplacez vers la page du haut',
  wrong_left: 'Déplacez vers la page de gauche',
  wrong_right: 'Déplacez vers la page de droite',
  flip_to_back_side: 'Retournez au verso',
  move_top: 'Déplacez-vous vers la page du haut',
  move_left: 'Déplacez-vous vers la page de gauche',
  move_right: 'Déplacez-vous vers la page de droite',
  scan_the_back_side: 'Scannez le verso du document',
  scan_the_barcode: 'Scannez le code-barres',
  move_closer: 'Approchez le document',
  move_farther: 'Éloignez le document',
  camera_angle_too_steep: 'Gardez le document parallèle au téléphone',
  face_photo_not_fully_visible: 'Gardez la photo du visage entièrement visible',
  document_too_close_to_edge: 'Éloignez le document du bord',
  blur_detected: 'Gardez le document et le téléphone immobiles',
  glare_detected: 'Inclinez ou déplacez le document pour enlever le reflet',
  occluded: 'Gardez le document entièrement visible',
  too_dark: 'Déplacez-vous vers un endroit plus lumineux',
  too_bright: 'Déplacez-vous vers un endroit moins lumineux',
  scan_unsuccessful: 'Échec du scan',
  scan_unsuccessful_details:
    'Impossible de lire le document. Veuillez réessayer.',
  error_occurred: 'Erreur survenue',
  sdk_initialization_error: 'Erreur lors de l’initialisation du SDK',
  sdk_initialization_error_details:
    "Une erreur est survenue lors de l'initialisation du SDK BlinkID.",
  camera_error: 'Erreur de caméra',
  camera_permission_denied:
    "Accès à la caméra refusé. Veuillez autoriser l'accès à la caméra et réessayer.",
  scan_time_exceeded: 'Temps de scan dépassé',
  scan_taking_longer_hint:
    'Le processus de numérisation prend plus de temps que prévu. Veuillez vous assurer que le document est bien éclairé, net et correctement positionné dans le cadre de la caméra.',
  document_not_supported: 'Document non pris en charge',
  try_different_document: 'Essayer un autre document',
  document_not_supported_hint:
    'Le document que vous tentez de scanner n’est pas pris en charge par cette application. Essayez de scanner un document différent.',
  document_not_recognized: 'Document non reconnu',
  document_not_recognized_details:
    'Scannez le recto d’un document pris en charge.',
  document_filtered: 'Document non accepté',
  label_from: 'de',
  onboarding_modal_title: 'Gardez tous les détails visibles',
  onboarding_modal_details:
    'Assurez-vous que le document est bien éclairé. Tous les champs doivent être visibles à l’écran.',
  onboarding_modal_btn: 'Commencer le scan',
  help_modal_title_1: 'Gardez tous les champs visibles',
  help_modal_details_1:
    'Ne couvrez aucune partie du document avec votre doigt, y compris les lignes du bas. Faites attention aux reflets d’hologramme.',
  help_modal_title_2: 'Évitez la lumière directe',
  help_modal_details_2:
    'La lumière directe peut créer des reflets qui rendent le document illisible. Si les données sont illisibles, la caméra ne peut pas les lire non plus.',
  help_modal_title_3: 'Restez immobile pendant le scan',
  help_modal_details_3:
    'Essayez de maintenir le téléphone et le document immobiles pendant le scan.',
  help_modal_back_btn: 'Retour',
  help_modal_next_btn: 'Suivant',
  help_modal_done_btn: 'Terminé',
  help_aria_label: 'Aide',
  help_tooltip: 'Besoin d’aide ?',
  alert_retry_btn: 'Réessayer',
  alert_cancel_btn: 'Annuler',
  screen_photo_error:
    'Ne photographiez pas un écran. Utilisez le document original.',
  glare_photo_error:
    'Reflets détectés. Évitez la lumière directe ou les reflets.',
  copy_or_screenshot_photo_error:
    'Le document semble être une copie ou une capture d’écran. Veuillez utiliser le document original.',
  invalid_document_photo_error:
    'Le document est incomplet, invalide ou incohérent. Veuillez le vérifier.',
  front_side_blur_or_glare_error:
    'La face avant est floue, présente des reflets ou n’a pas été détectée correctement.',
  both_sides_required_error:
    'Pour ce type de document, les deux côtés doivent être téléchargés. Veuillez télécharger le deuxième côté.',
  invalid_file_type:
    'Type de fichier invalide. Veuillez télécharger un JPG, JPEG ou PNG.',
  file_too_large_error:
    'Le fichier est trop volumineux. Maximum 5 Mo autorisés.',
  scan_successful: 'Scan réussi.',
} as const;
